import { OrderResultsService } from "../../../services/orderResults.service";
import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { AuthService } from "src/app/services";
import * as fileSaver from "file-saver";
import { MatSort, MatTableDataSource } from "@angular/material";
// import {ConfirmDeleteComponent} from 'src/app/components/confirm-delete/confirm-delete.component'
// import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: "app-list",
  templateUrl: "./list.component.html",
  styleUrls: ["./list.component.scss"],
})
export class ListComponent implements OnInit, AfterViewInit {
  customer: any;

  pageIndex: number = 0;
  pageSize: number = 10;
  totalResult: number = 0;
  totalPage: number = 0;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  displayedColumns: string[] = [
    "index",
    "delete",
    "download",
    "code",
    "name",
    "phone",
    "email",
    "note",
    "create_date",
  ];

  dataSource = new MatTableDataSource<any>();
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    // private confirmDeleteComponent: ConfirmDeleteComponent,
    private orderResultsService: OrderResultsService,
    private authenticationService: AuthService // private modalService: NgbModal
  ) {

  }

  ngAfterViewInit(): void {
    this.dataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case "name":
          return item.customerName;
        case 'phone':
          return item.phoneNumber;
        case 'create_date':
          return item.createdDate;
        default:
          return item[property];
      }
    };
    console.log(this)
  }

  ngOnInit() {
    this.search();
  }

  delete(item) {
    var today = new Date();
    var date =
      today.getDate() +
      "-" +
      (today.getMonth() + 1) +
      "-" +
      today.getFullYear();
    console.log(date);
    // const modalRef = this.modalService.open(ConfirmDeleteComponent);
    // modalRef.result.then((result)=>{
    // 	this.orderResultsService.deleteList(item.id).subscribe((result)=>{
    // 		if(result){
    // 			alert("Xóa thành công");
    // 		}else{
    // 			alert("Thao tác bị lỗi")
    // 		}
    // 	});
    // }).catch((result)=>{
    // 	console.log("trả về" +result);
    // })
  }

  search() {
    this.orderResultsService
      .getOderTable(this.pageSize, this.pageIndex + 1)
      .subscribe((result) => {
        if (result.error === "unauthorized") {
          this.authenticationService.logout();
        }

        this.dataSource.data = result.data;
        this.dataSource.sort = this.sort;

        this.totalPage = result.totalPage;
        this.pageIndex = result.currentPage - 1;
        this.totalResult = result.totalResult;
      });
  }

  onPageChange(event: any) {
    if (this.pageSize !== event.pageSize) {
      this.pageIndex = 0;
      this.pageSize = event.pageSize;
    } else {
      this.pageIndex = event.pageIndex;
    }

    this.search();
  }

  dowload(item) {
    var today = new Date();
    var date =
      today.getDate() +
      "-" +
      (today.getMonth() + 1) +
      "-" +
      today.getFullYear();
    var text1 = JSON.stringify(item.roomData);
    this.customer = item.phoneNumber + "-" + item.customerName + "." + date;

    if (!item.phoneNumber || item.phoneNumber.size < 0) {
      this.customer = item.customerName + "." + date;
    } else
      this.customer = item.phoneNumber + " " + item.customerName + "." + date;
    text1 = text1.slice(1, text1.length - 1);
    text1 = text1.replace(/\\/g, "");
    try {
      let result = this.convert(text1);
    } catch (e) {
      alert("Không dowload được !");
      console.error(e);
    }
    console.log("result = ");
  }
  mtl_string =
    "\
    # Material Count: 13\n\
    newmtl floor\n\
    Ka 0.0 0.0 0.0\n\
    Kd 0.0 0.0 0.0\n\
    Ks 0.0 0.0 0.0\n\
    d 0.39\n\
    \n\
    newmtl ceiling\n\
    Ka 0.0 0.0 0.0\n\
    Kd 0.97 0.89 0.7\n\
    Ks 0.0 0.0 0.0\n\
    d 0.196\n\
    \n\
    newmtl wall\n\
    Ka 0.0 0.0 0.0\n\
    Kd 0.74 0.61 0.45\n\
    Ks 0.0 0.0 0.0\n\
    d 0.39\n\
    \n\
    newmtl doorList\n\
    Ka 0.0 0.0 0.0\n\
    Kd 0.0 0.15 0.215\n\
    Ks 0.0 0.0 0.0\n\
    d 0.39\n\
    \n\
    newmtl windowList\n\
    Ka 0.0 0.0 0.0\n\
    Kd 0.0 0.69 1.0\n\
    Ks 0.0 0.0 0.0\n\
    d 0.47\n\
    \n\
    newmtl subWindowsList\n\
    Ka 0.0 0.0 0.0\n\
    Kd 0.0 0.69 1.0\n\
    Ks 0.0 0.0 0.0\n\
    d 0.47\n\
    \n\
    newmtl holeList\n\
    Ka 0.0 0.0 0.0\n\
    Kd 0.79 0.67 0.55\n\
    Ks 0.0 0.0 0.0\n\
    d 0.39\n\
    \n\
    newmtl ventilatorList\n\
    Ka 0.0 0.0 0.0\n\
    Kd 1.0 1.0 1.0\n\
    Ks 0.0 0.0 0.0\n\
    d 0.39\n\
    \n\
    newmtl airConList\n\
    Ka 0.0 0.0 0.0\n\
    Kd 1.0 1.0 1.0\n\
    Ks 0.0 0.0 0.0\n\
    d 0.39\n\
    \n\
    newmtl switchSocektList\n\
    Ka 0.0 0.0 0.0\n\
    Kd 1.0 1.0 1.0\n\
    Ks 0.0 0.0 0.0\n\
    d 0.39\n\
    \n\
    newmtl furnitureList\n\
    Ka 0.0 0.0 0.0\n\
    Kd 0.37 0.157 1.0\n\
    Ks 0.0 0.0 0.0\n\
    d 0.39\n\
    \n\
    newmtl bulkheadList\n\
    Ka 0.0 0.0 0.0\n\
    Kd 0.37 0.157 1.0\n\
    Ks 0.0 0.0 0.0\n\
    d 0.39\n\
    \n\
    newmtl dividedSpaceList\n\
    Ka 0.0 0.0 0.0\n\
    Kd 0.97 0.0 0.13\n\
    Ks 0.0 0.0 0.0\n\
    d 0.39\n\
    \n";

  getPositions(a) {
    var v = [];
    let n = a.length;
    for (let i = 0; i < n; i++) {
      let x = a[i].x;
      let y = a[i].y;
      let z = -a[i].z;
      let vertex = [x, y, z];
      v.push(vertex);
    }
    console.log(n);
    return v;
  }

  // return one oplygon in obj format, given a material name
  addPolygon(materialName, nVertices, firstIndex, reverse) {
    var ret = "";
    if (materialName) ret += "usemtl " + materialName + "\n";
    ret += "f ";
    for (let i = 0; i < nVertices; i++) {
      ret += i + firstIndex;
      if (i < nVertices - 1) ret += " ";
    }
    ret += "\n";

    ret += "f ";
    for (let i = nVertices - 1; i >= 0; i--) {
      ret += i + firstIndex;
      if (i > 0) ret += " ";
    }

    ret += "\n";
    return ret;
  }

  // return a string with polygons for a given material
  addPolygons(materialName, polygons, reverse) {
    var ret = "";
    if (materialName) ret += "usemtl " + materialName + "\n";
    for (let k = 0; k < polygons.length; k++) {
      ret += "f ";
      for (let i = 0; i < polygons[k].length; i++) {
        ret += polygons[k][i];
        if (i < polygons[k].length - 1) ret += " ";
      }
      ret += "\n";
    }
    for (let k = 0; k < polygons.length; k++) {
      ret += "f ";
      for (let i = polygons[k].length - 1; i >= 0; i--) {
        ret += polygons[k][i];
        if (i > 0) ret += " ";
      }
      ret += "\n";
    }

    return ret;
  }

  addVertices(target, source) {
    for (let i = 0; i < source.length; i++)
      target.push([source[i][0], source[i][1], source[i][2]]);
  }

  // n walls
  addWalls(firstIndex, n) {
    let ret = "usemtl wall\n";
    for (
      let p = 0;
      p < n;
      p++ // n quad polygons
    ) {
      let a = firstIndex + p;
      let b = firstIndex + ((p + 1) % n);
      let c = b + n;
      let d = a + n;
      ret += "f " + a + " " + b + " " + c + " " + d + "\n";
      ret += "f " + d + " " + c + " " + b + " " + a + "\n";
    }
    return ret;
  }

  getPolygons(input) {
    let polygons = [];
    if (!input) return [];
    if (input.length == 0) return [];
    let n = input.length;
    let p = [];
    for (let i = 0; i < n; i++) {
      if (input[i].x == undefined) {
        // enumerate objects
        for (var e in input[i]) {
          let ret = this.getPolygons(input[i][e]);
          if (ret) {
            for (let j = 0; j < ret.length; j++) polygons.push(ret[j]);
          }
        }
      } else {
        let x = input[i].x;
        let y = input[i].y;
        let z = -input[i].z;
        p.push([x, y, z]);
      }
    }
    if (p.length != 0) polygons.push(p);
    return polygons;
  }

  // n walls
  connectPoints(firstIndex, n) {
    let polygons = [];
    for (
      let p = 0;
      p < n;
      p++ // n quad polygons
    ) {
      let pol = [];
      pol.push(firstIndex + p);
      pol.push(firstIndex + ((p + 1) % n));
      pol.push(firstIndex + n + ((p + 1) % n));
      pol.push(firstIndex + p + n);
      polygons.push(pol);
    }
    return polygons;
  }

  // return a list of vertices, and one polygon made of these vertices
  getLoop(a, firstIndex) {
    var v = [];
    var pol = [];
    let n = a.length;
    for (let i = 0; i < n; i++) {
      let x = a[i].x;
      let y = a[i].y;
      let z = -a[i].z;
      let vertex = [x, y, z];
      v.push(vertex);
      pol.push(firstIndex + i);
    }
    return [v, pol];
  }

  processFurniture(furnitureList, firstIndex) {
    // "furnitureList", "furnitureBottomPositions", "furnitureTopPositions"
    let polygons = [];
    let vertices = [];
    if (!furnitureList) return [vertices, polygons];
    if (furnitureList.length == 0) return [vertices, polygons];
    let currIndex = firstIndex;
    for (let i = 0; i < furnitureList.length; i++) {
      if (
        furnitureList[i].furnitureBottomPositions &&
        furnitureList[i].furnitureTopPositions
      ) {
        let length1 = furnitureList[i].furnitureBottomPositions.length;
        let length2 = furnitureList[i].furnitureTopPositions.length;
        if (length1 != length2) {
          console.log(
            "Error: furnitureBottomPositions and furnitureTopPositions should have the same size"
          );
          return [[], []];
        }
        let pol = [];
        for (let j = 0; j < length1; j++) {
          let x = furnitureList[i].furnitureBottomPositions[j].x;
          let y = furnitureList[i].furnitureBottomPositions[j].y;
          let z = -furnitureList[i].furnitureBottomPositions[j].z;
          vertices.push([x, y, z]);
          pol.push(currIndex + j);
        }
        polygons.push(pol);
        pol = [];
        for (let j = 0; j < length2; j++) {
          let x = furnitureList[i].furnitureTopPositions[j].x;
          let y = furnitureList[i].furnitureTopPositions[j].y;
          let z = -furnitureList[i].furnitureTopPositions[j].z;
          vertices.push([x, y, z]);
          pol.push(currIndex + length1 + j);
        }
        polygons.push(pol);

        // receiving a list of polygons
        pol = this.connectPoints(currIndex, length1);
        for (let j = 0; j < pol.length; j++) polygons.push(pol[j]);

        currIndex += length1 + length2;
      }
    }

    return [vertices, polygons];
  }

  processHole(holeList, firstIndex) {
    // "holeList", "holePositions", "holeEndPositions"
    let polygons = [];
    let vertices = [];
    if (!holeList) return [vertices, polygons];
    if (holeList.length == 0) return [vertices, polygons];
    let currIndex = firstIndex;
    for (let i = 0; i < holeList.length; i++) {
      if (holeList[i].holePositions && holeList[i].holeEndPositions) {
        let length1 = holeList[i].holePositions.length;
        let length2 = holeList[i].holeEndPositions.length;
        if (length1 != length2) {
          console.log(
            "Error: holePositions and holeEndPositions should have the same size"
          );
          return [[], []];
        }
        let pol = [];
        for (let j = 0; j < length1; j++) {
          let x = holeList[i].holePositions[j].x;
          let y = holeList[i].holePositions[j].y;
          let z = -holeList[i].holePositions[j].z;
          vertices.push([x, y, z]);
          pol.push(currIndex + j);
        }
        polygons.push(pol);
        pol = [];
        for (let j = 0; j < length2; j++) {
          let x = holeList[i].holeEndPositions[j].x;
          let y = holeList[i].holeEndPositions[j].y;
          let z = -holeList[i].holeEndPositions[j].z;
          vertices.push([x, y, z]);
          pol.push(currIndex + length1 + j);
        }
        polygons.push(pol);

        // receiving a list of polygons
        pol = this.connectPoints(currIndex, length1);
        for (let j = 0; j < pol.length; j++) polygons.push(pol[j]);

        currIndex += length1 + length2;
      }
    }

    return [vertices, polygons];
  }

  processBulkhead(bulkheadList, firstIndex) {
    //bulkheadList  "bulkheadBottomPositions" and "bulkheadTopPositions"
    let polygons = [];
    let vertices = [];
    if (!bulkheadList) return [vertices, polygons];
    if (bulkheadList.length == 0) return [vertices, polygons];
    let currIndex = firstIndex;
    for (let i = 0; i < bulkheadList.length; i++) {
      if (bulkheadList[i].holePositions && bulkheadList[i].holeEndPositions) {
        let length1 = bulkheadList[i].bulkheadBottomPositions.length;
        let length2 = bulkheadList[i].bulkheadTopPositions.length;
        if (length1 != length2) {
          console.log(
            "Error: holePositions and holeEndPositions should have the same size"
          );
          return [[], []];
        }
        let pol = [];
        for (let j = 0; j < length1; j++) {
          let x = bulkheadList[i].bulkheadBottomPositions[j].x;
          let y = bulkheadList[i].bulkheadBottomPositions[j].y;
          let z = -bulkheadList[i].bulkheadBottomPositions[j].z;
          vertices.push([x, y, z]);
          pol.push(currIndex + j);
        }
        polygons.push(pol);
        pol = [];
        for (let j = 0; j < length2; j++) {
          let x = bulkheadList[i].bulkheadTopPositions[j].x;
          let y = bulkheadList[i].bulkheadTopPositions[j].y;
          let z = -bulkheadList[i].bulkheadTopPositions[j].z;
          vertices.push([x, y, z]);
          pol.push(currIndex + length1 + j);
        }
        polygons.push(pol);

        // receiving a list of polygons
        pol = this.connectPoints(currIndex, length1);
        for (let j = 0; j < pol.length; j++) polygons.push(pol[j]);

        currIndex += length1 + length2;
      }
    }

    return [vertices, polygons];
  }

  saveOBJ(obj, mtl) {
    var data = obj;

    //Creas un link para descagar la broma
    var a = window.document.createElement("a");
    a.href = window.URL.createObjectURL(
      new Blob([data], { type: "plain/text" })
    );
    a.download = "default" + ".obj";

    //Le haces click
    document.body.appendChild(a);
    a.click();

    var name = a.download;
    document.body.removeChild(a);
    //a = null;

    if (name) name = name.replace(/\.[^.]+$/, ".mtl");

    var data = mtl;
    var b = window.document.createElement("b");
    // b.href = window.URL.createObjectURL(new Blob([data], { type: 'plain/text'}));
    // b.download = name;
    //document.body.appendChild(a);
    b.click();
    document.body.removeChild(b);
    //a = null;
  }

  convert(text) {
    let obj = "";
    let mtl = "";
    let n = 0;
    console.log("hiện trong conver:" + text);
    var parser = JSON.parse(text);
    if (!parser) return "unparseable json text";
    // vertices
    let v = [];

    // polygons
    let p = [];
    let roomData = parser;
    if (!roomData) return "invalid json text: room data does not exist in json";
    console.log("roomData exists");

    // FLOOR
    let floorPositions = this.getPositions(roomData["floorPositions"]);
    if (!floorPositions) return "floorPositions error";
    // 1-based index
    obj += this.addPolygon("floor", floorPositions.length, v.length + 1, false);
    this.addVertices(v, floorPositions);
    let wallHeight = roomData.wallHeight;
    if (!wallHeight) return "wallHeight not found";

    // CEILING
    for (let i = 0; i < floorPositions.length; i++)
      floorPositions[i][1] = wallHeight;
    obj += this.addPolygon(
      "ceiling",
      floorPositions.length,
      v.length + 1,
      true
    );
    this.addVertices(v, floorPositions);

    //WALLS
    obj += this.addWalls(
      v.length + 1 - 2 * floorPositions.length,
      floorPositions.length
    );

    var listNames = [
      "doorList",
      /*"windowList", */ "subWindowsList",
      "ventilatorList",
      "airConList",
      "switchSocektList",
      "dividedSpaceList",
    ];

    for (let i = 0; i < listNames.length; i++) {
      let polygons = this.getPolygons(roomData[listNames[i]]);
      if (polygons.length > 0) {
        obj += "usemtl " + listNames[i] + "\n";
        for (let j = 0; j < polygons.length; j++) {
          obj += this.addPolygon(null, polygons[j].length, v.length + 1, false);
          this.addVertices(v, polygons[j]);
        }
      }
    }

    var res = this.processHole(roomData["holeList"], v.length + 1);
    // res[0] = vertices
    // res[1] = polygons
    if (res[0].length > 0) this.addVertices(v, res[0]);
    if (res[1].length > 0) obj += this.addPolygons("holeList", res[1], false);

    res = this.processFurniture(roomData["furnitureList"], v.length + 1);
    // res[0] = vertices
    // res[1] = polygons
    if (res[0].length > 0) this.addVertices(v, res[0]);
    if (res[1].length > 0)
      obj += this.addPolygons("FurnitureList", res[1], false);

    res = this.processBulkhead(roomData["bulkheadList"], v.length + 1);
    // res[0] = vertices
    // res[1] = polygons
    if (res[0].length > 0) this.addVertices(v, res[0]);
    if (res[1].length > 0)
      obj += this.addPolygons("FurnitureList", res[1], false);

    let vertices = "";
    for (let i = 0; i < v.length; i++)
      vertices += "v " + v[i][0] + " " + v[i][1] + " " + v[i][2] + "\n";

    obj = "# " + v.length + " vertices\n" + "mtllib a.mtl\n" + vertices + obj;

    mtl = this.mtl_string;

    //saveOBJ(obj,mtl);
    var blob_obj = new Blob([obj], { type: "text/plain;charset=utf-8" });
    fileSaver(blob_obj, this.customer + ".obj");

    var blob_mtl = new Blob([mtl], { type: "text/plain;charset=utf-8" });
    fileSaver(blob_mtl, this.customer + ".mtl");

    return [obj, mtl];
  }

  //////////////////
  // MAIN PROGRAM //
  //////////////////
}
